import type { ExtractPropTypes } from 'vue'

import { buildProps, definePropType } from '@ll-plus/utils'

import { FloatButtonProps as AntFloatButtonProps } from 'ant-design-vue'
import { IconProps } from '../../icon'

import type FloatButtonGroup from './float-button-group.vue'
import type FloatButton from './float-button.vue'

export const floatButtonProps = buildProps({
  //  图标信息
  icon: {
    type: definePropType<IconProps>(Object),
    default: () => ({
      iconName: '',
      color: '',
      size: '',
    }),
  },
  enableBadge: {
    type: Boolean,
    default: true,
  },
  badge: {
    type: definePropType<AntFloatButtonProps['badge']>(Object),
  },
  description: {
    type: String,
    default: '',
  },
  shape: {
    type: String,
    values: ['circle', 'square'],
    default: 'circle',
  },
} as const)

export const floatButtonGroupProps = buildProps({
  icon: {
    type: definePropType<IconProps>(Object),
    default: () => ({
      iconName: '',
      color: '',
      size: '',
    }),
  },
  menus: {
    type: Array as any,
    default: () => [],
  },
  trigger: {
    type: String,
    values: ['click', 'hover', ''],
    default: undefined,
  },
} as const)

// props
export type FloatButtonProps = ExtractPropTypes<typeof floatButtonProps>
export type FloatButtonGroupProps = ExtractPropTypes<
  typeof floatButtonGroupProps
>

// instance
export type FloatButtonInstance = InstanceType<typeof FloatButton>
export type FloatButtonGroupInstance = InstanceType<typeof FloatButtonGroup>
